import React, { FC, ReactNode } from 'react';
import { Navigate, Params, useLocation, useParams } from 'react-router-dom';
import { ERoute } from 'common/const';
import { canAccessRoute } from 'common/helpers';
import { allowedRfpRoutes, allowedSettingsRoutes } from 'common/helpers/route.helper';
import { useAppSelector } from 'app/store/store.hooks';
import { IToken } from 'entities/Auth/Auth.models';
import { getUserRole } from 'entities/User/User.helper';
import { selectAuth } from 'entities/Auth/Auth.slice';

interface IComponentProps {
  children: ReactNode;
  allowedRoles: string[];
  condition?: (params: { auth: IToken | null; params: Readonly<Params<string>> }) => boolean;
}

export const ProtectedRoute: FC<IComponentProps> = ({ children, allowedRoles, condition }) => {
  // auth
  const auth = useAppSelector(selectAuth);

  const params = useParams();
  const location = useLocation();

  const roles = auth?.access.roles;
  const { isSuperAdmin } = getUserRole(roles);
  let canAccess = !roles?.length || roles?.some((role) => allowedRoles.includes(role));

  if (condition) {
    canAccess = canAccess && condition({ auth, params });
  }

  if (location.pathname.startsWith(ERoute.Settings)) {
    canAccess = canAccessRoute(location.pathname, auth, allowedSettingsRoutes);
  }

  if (location.pathname.startsWith('/rfp')) {
    canAccess = canAccessRoute(location.pathname, auth, allowedRfpRoutes);
  }

  if (!canAccess) {
    return isSuperAdmin ? <Navigate to={ERoute.AccountList} replace /> : <Navigate to={ERoute.Profile} replace />;
  }

  return children;
};
